<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/G1V0aO/tc-custom/9780292786974.jpg?1733093872068" alt="This image is the cover for the book Images from the Underworld"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Images from the Underworld
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An in-depth look at Maya cave painting from Preconquest times to the Colonial period, plus a complete visual catalog of the cave art of Naj Tunich.</b></p><p>In 1979, a Kekchi Maya Indian accidentally discovered the entrance to Naj Tunich, a deep cave in the Maya Mountains of El Peten, Guatemala. One of the world’s few deep caves that contain rock art, Naj Tunich features figural images and hieroglyphic inscriptions that have helped to revolutionize our understanding of ancient Maya art and ritual.</p><p>In this book, Andrea Stone takes a comprehensive look at Maya cave painting from Preconquest times to the Colonial period. After surveying Mesoamerican cave and rock painting sites and discussing all twenty-five known painted caves in the Maya area, she focuses extensively on Naj Tunich. Her text analyzes the images and inscriptions, while photographs and line drawings provide a complete visual catalog of the cave art, some of which has been subsequently destroyed by vandals.</p><p>This important new body of images and texts enlarges our understanding of the Maya view of sacred landscape and the role of caves in ritual. It will be important reading for all students of the Maya, as well as for others interested in cave art and in human relationships with the natural environment.</p><b>“Not only an extraordinarily detailed and insightful analysis of the painted representations and texts found in Naj Tunich but also a complete survey of all known Maya painted caves. . . . A major monograph on a major Maya site. For completeness of presentation, for clarity of writing, and for depth and scope of analysis, [<i>Images from the Underworld</i>] is a model of what a final report should be.” —<i>Journal of Anthropological Research</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrea J. Stone
      </h2>
      
      <p class="authorDescription body article">Andrea Stone is Associate Professor of Art History at the University of Wisconsin–Milwaukee.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Texas Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0494a3c2